// Counter Animation
$(document).ready(function () {
  function animateCounter($el, target) {
    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function () {
          $el.text(this.countNum.toLocaleString("de-DE"));
        },
      },
    );
  }
  function startCounters() {
    $(".counter").each(function () {
      var $this = $(this);
      var target = parseInt($this.data("target"));
      if (
        !$this.hasClass("counted") &&
        $(window).scrollTop() + $(window).height() > $this.offset().top
      ) {
        animateCounter($this, target);
        $this.addClass("counted");
      }
    });
  }
  $(window).on("scroll", startCounters);
  startCounters();

  // Scroll Reveal Observer (.rv -> .in)
  if ('IntersectionObserver' in window) {
    const rvObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          rvObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rv').forEach((el) => rvObserver.observe(el));
  } else {
    document.querySelectorAll('.rv').forEach((el) => el.classList.add('in'));
  }

  // Lead Form Submission
  const leadForm = document.getElementById('leadForm');
  if (leadForm) {
    const bad = (id, b) => {
      const el = document.getElementById(id);
      if (el) el.closest('.fg')?.classList.toggle('bad', b);
    };
    const phoneRegex = /^(0|\+84)\d{9,10}$/;

    leadForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const nameInput = document.getElementById('name');
      const phoneInput = document.getElementById('phone');
      const prodInput = document.getElementById('prod');
      const emailInput = document.getElementById('email');
      const submitBtn = leadForm.querySelector('button[type="submit"]');

      const isNameBad = !nameInput?.value.trim();
      const cleanPhone = (phoneInput?.value || '').replace(/[\s.\-()]/g, '');
      const isPhoneBad = !phoneRegex.test(cleanPhone);
      const isProdBad = !prodInput?.value;

      bad('name', isNameBad);
      bad('phone', isPhoneBad);
      bad('prod', isProdBad);

      if (isNameBad || isPhoneBad || isProdBad) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Đang gửi...';
      }

      const fd = new URLSearchParams();
      fd.append('action', 'vua_lead');
      fd.append('name', nameInput.value.trim());
      fd.append('phone', cleanPhone);
      fd.append('email', (emailInput?.value || '').trim());
      fd.append('prod', prodInput.value);

      const ajaxUrl = (window.vuaAjax && vuaAjax.url) || '/wp-admin/admin-ajax.php';
      fetch(ajaxUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: fd,
      })
        .then((r) => r.json())
        .catch(() => ({}))
        .then(() => {
          leadForm.style.display = 'none';
          const qok = document.getElementById('qok');
          if (qok) qok.style.display = 'block';
        });
    });
  }

  // Floating Action Button (FAB) Toggle
  const fab = document.getElementById('fab');
  const fabBtn = document.getElementById('fabBtn');
  if (fab && fabBtn) {
    fabBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = fab.classList.toggle('is-open');
      fabBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', (e) => {
      if (fab.classList.contains('is-open') && !fab.contains(e.target)) {
        fab.classList.remove('is-open');
        fabBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }
});


